const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ErrorUtil = require("../../../shared/ErrorUtil");
const SCUUtil = require("../util/SCUUtil");
const {getBaseInstance} = require("../util/HOCUtil");
const withContainerDims = require("../hoc/withContainerDims");

const CONSECUTIVE_RENDER_LIMIT = 10;

// This view creates an empty div (or specified tag name) and queries its width
// and height, then renders its single child inside the div while providing its
// width and height as props. It was made to allow CSS to determine the size of
// Canvas elements, whose size needs to be specified in Javascript. Also passes
// down containerDims as a bonus.

// In new code, prefer the renderChild prop over children.

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component, {skipOnServer: true});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "MeasuredEl",

		propTypes: {
			// There are two ways to specify the child to render. The legacy way is
			// to use the children prop and the names of the size properties to pass
			// in (all with defaults).
			children: PT.element,
			widthPropName: PT.string.isRequired,
			heightPropName: PT.string.isRequired,
			isMeasuredPropName: PT.string,
			// The second way, preferred in new code, is to provide a render function
			// taking an object with {width, height, containerDims}.
			renderChild: PT.func,

			tagName: PT.string.isRequired,
			className: PT.string,
			style: PT.object,
			// Adds an extra position absolute div just below the measured one to avoid
			// CSS height ping pong
			useAbsoluteDiv: PT.bool,
			// Use getBoundingClientRect to measure element, instead of clientWidth and
			// clientHeight. See determineSize for pros/cons.
			useBoundingClientRect: PT.bool,
			//Don't rerender on containerDims changing (size changes)
			skipRenderOnResize: PT.bool,
			dataTestId: PT.string,

			// Injected by HOCs
			// We don't actually use this except to check if a rerender is needed.
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getDefaultProps: function() {
			return {
				tagName: "div",
				widthPropName: "width",
				heightPropName: "height",
				isMeasuredPropName: "isMeasured",
			};
		},

		getInitialState: function() {
			return this.determineSize();
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			const changed =
				this.props.tagName !== nextProps.tagName ||
				this.props.className !== nextProps.className ||
				(!nextProps.skipRenderOnResize &&
					this.props.containerDims !== nextProps.containerDims) ||
				!_.isEqual(this.props.style, nextProps.style);
			if (changed) {
				this.setState(this.determineSize());
			}
		},

		shouldComponentUpdate: function(nextProps, nextState) {
			if (
				nextProps.skipRenderOnResize &&
				SCUUtil.shallowEq(
					_.omit(nextProps, "containerDims"),
					_.omit(this.props, "containerDims")
				) &&
				SCUUtil.shallowEq(nextState, this.state)
			) {
				//Skip updating if the skipRenderOnResize prop is set and only the containerDims changed.
				return false;
			} else {
				return true;
			}
		},

		determineSize: function() {
			const el = this.containerEl;
			if (!el) {
				return {width: 0, height: 0};
			} else if (this.props.useBoundingClientRect) {
				// clientWidth and clientHeight round, and this doesn't. Use this if
				// very precise sizing is needed.
				const rect = el.getBoundingClientRect();
				return {width: rect.width, height: rect.height};
			} else {
				// getBoundingClientRect respects animation, and this doesn't, so it will
				// trigger E_MEASURE_COMP_LOOP for an animating element. Use this if an
				// element animates.
				return {width: el.clientWidth, height: el.clientHeight};
			}
		},

		componentDidMount: function() {
			this.setState(this.determineSize()); // eslint-disable-line react/no-did-mount-set-state
		},

		componentDidUpdate: function() {
			setTimeout(() => this.doSizeRecheckHack(), 0);
		},

		componentWillUnmount: function() {
			this.unmounted = true;
		},

		// Check the container size and see if it's different from the current size.
		// If so, set the state again.
		// Without this, the measured size seems to be one render behind sometimes.
		doSizeRecheckHack: function() {
			try {
				if (this.unmounted) {
					return;
				}
				// Since this check is done in componentDidUpdate and can trigger a
				// rerender, we guard against the possibility of infinite render loops.
				const consecutiveRenders = this.consecutiveRenders || 0;
				// Reset the value here to avoid having to reset it in all branches but the
				// one with setState.
				this.consecutiveRenders = 0;

				if (consecutiveRenders >= CONSECUTIVE_RENDER_LIMIT) {
					ErrorUtil.log(
						"E_MEASURE_COMP_LOOP",
						"More than " +
							consecutiveRenders +
							" " +
							"renders in a row trying to measure a MeasuredEl. " +
							"Terminating.",
						_.omit(this.props, ["children"])
					);
					return;
				}

				const newState = this.determineSize();
				if (
					newState.width === this.state.width &&
					newState.height === this.state.height
				) {
					return;
				}

				// Reached setState; this.consecutiveRenders needs to be one higher than
				// the original value.
				this.consecutiveRenders = consecutiveRenders + 1;
				return this.setState(newState);
			} catch (ex) {
				// T12754 shows the setState throwing for as yet undetermined reasons.
				// Since this function is not totally essential, we'll log and swallow
				// the error.
				ErrorUtil.log(
					"E_MEASURE_COMP_RECHECK",
					ex,
					_.omit(this.props, ["children"])
				);
			}
		},

		render: function() {
			let child = null;
			const renderChild =
				this.props.renderChild ||
				(({width, height, containerDims}) => {
					const childProps = _.extend({}, this.props.children.props, {
						[this.props.widthPropName]: width,
						[this.props.heightPropName]: height,
						[this.props.isMeasuredPropName]: true,
						containerDims: containerDims,
					});
					return _.extend({}, this.props.children, {props: childProps});
				});
			if (this.state.width && this.state.height) {
				child = renderChild({
					width: this.state.width,
					height: this.state.height,
					containerDims: this.props.containerDims,
				});
			}
			let style = this.props.style || {};
			if (this.props.useAbsoluteDiv) {
				const fullSize = {
					position: "absolute",
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
				};
				child = <div style={fullSize}>{child}</div>;
				style = _.extend({}, style, {position: "relative"});
			}
			const TagName = this.props.tagName;
			return (
				<TagName
					className={this.props.className || ""}
					style={style}
					ref={ref => (this.containerEl = getBaseInstance(ref))}
					data-testid={this.props.dataTestId}
				>
					{child}
				</TagName>
			);
		},
	})
);
